window.skimlinks_exclude = window.js_vars.skimlinks_exclude;
